import { Component, Input } from '@angular/core';
import { CloneableLogonSearch } from '../../../../interfaces/cloneable-logon-search.interface';
import { IUserAddSearchMessagesHelper } from '../../helpers/user-add-search-messages.helper';

@Component({
  selector: 'pl-step-products',
  templateUrl: './step-products.component.html',
  styleUrls: ['./step-products.component.scss'],
  standalone: false,
})
export class StepProductsComponent {
  @Input() cloneableLogon: CloneableLogonSearch | undefined;
  @Input() subtitle?: string;
  @Input() contentTextForInformation?: string;
  @Input() hasError = false;
  @Input() errorMessage: IUserAddSearchMessagesHelper | undefined;
  @Input() pmeLimitReached = false;
}
